import { render, staticRenderFns } from "./IconAnimations.vue?vue&type=template&id=5a7d42f4"
import script from "./IconAnimations.vue?vue&type=script&lang=js"
export * from "./IconAnimations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports